import React from "react";
import { ModalCompAdvance, ButtonComp } from "../../../../components";
import { useGetSingleEminuteQuery } from "../../../../store/admin/eminutesSlice";
import { dateFromString } from "../../../../utils";
import { AiOutlineClose } from "react-icons/ai";

const EminuteDetailsModal = ({ show, handleClose, eminuteId }) => {
  const {
    data = {},
    isLoading,
    error,
  } = useGetSingleEminuteQuery(eminuteId, {
    skip: !eminuteId,
  });

  const modalContent = [
    {
      name: "E-Minute Details",
      component: (
        <div className="p-4">
          {isLoading ? (
            <div className="text-center py-4">
              <p>Loading...</p>
            </div>
          ) : error ? (
            <div className="text-center py-4">
              <p className="text-danger">Error loading E-minute details</p>
            </div>
          ) : (
            <>
              <div className="mb-4">
                <h5 className="fw-bold text-black1 mb-2">Title</h5>
                <p className="text-muted">{data.title || "No title"}</p>
              </div>

              <div className="mb-4">
                <h5 className="fw-bold text-black1 mb-2">Date</h5>
                <p className="text-muted">
                  {data.created_at
                    ? dateFromString(data.created_at)
                    : "No date"}
                </p>
              </div>

              <div className="mb-4">
                <h5 className="fw-bold text-black1 mb-2">Status</h5>
                <span
                  className={`badge ${
                    data.status === "PUBLISHED" ? "bg-success" : "bg-warning"
                  }`}
                >
                  {data.status || "Unknown"}
                </span>
              </div>

              <div className="mb-4">
                <h5 className="fw-bold text-black1 mb-2">Content</h5>
                <div
                  className="border rounded p-3 bg-light"
                  style={{
                    minHeight: "200px",
                    maxHeight: "400px",
                    overflowY: "auto",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: data.content || "No content available",
                  }}
                />
              </div>

              <div className="d-flex justify-content-end mt-4 pt-3 border-top">
                <ButtonComp
                  btnText="Close"
                  btnClassName="px-4 py-2 text-white rounded"
                  onClick={handleClose}
                  style={{ backgroundColor: "var(--color-primary)" }}
                />
              </div>
            </>
          )}
        </div>
      ),
    },
  ];

  return (
    <ModalCompAdvance
      show={show}
      handleClose={handleClose}
      arrayComp={modalContent}
      centered
      size="lg"
      close={true}
      modalTitle={
        <div className="d-flex justify-content-between align-items-center w-100">
          <h4 className="fw-bold mb-0" style={{ color: "var(--color-primary)" }}>
            E-Minute Details
          </h4>
          <AiOutlineClose
            onClick={handleClose}
            className="cursor-pointer"
            size={24}
            style={{ color: "var(--color-primary)" }}
          />
        </div>
      }
    />
  );
};

export default EminuteDetailsModal;
